module.exports = __webpack_public_path__ + "f1b7105560010b134191a2d23bfe0a21.svg";